import React from 'react';
import { USE_CASES, COLORS } from '../../data/siteData';

const UseCasesSection = () => {
  return (
    <section id="installations" className="py-20" style={{ backgroundColor: COLORS.background }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold mb-4" style={{ color: COLORS.dark }}>
            {USE_CASES.title}
          </h2>
          <p className="text-lg" style={{ color: COLORS.gray }}>
            {USE_CASES.subtitle}
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-8">
          {USE_CASES.items.map((useCase, index) => (
            <div 
              key={index}
              className="group relative rounded-2xl overflow-hidden shadow-lg hover:shadow-xl transition-all duration-300"
            >
              <div className="aspect-[4/3] overflow-hidden">
                <img
                  src={useCase.image}
                  alt={useCase.alt || `Knygomatas ${useCase.title.toLowerCase()}`}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                  loading="lazy"
                />
              </div>
              {/* Overlay */}
              <div className="absolute inset-0 bg-gradient-to-t from-black/80 via-black/40 to-transparent">
                <div className="absolute bottom-0 left-0 right-0 p-6">
                  <h3 className="text-xl font-bold text-white mb-2">
                    {useCase.title}
                  </h3>
                  <p className="text-white/80 text-sm">
                    {useCase.description}
                  </p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default UseCasesSection;
